import React from 'react'

const LayoutColorThemeContext = React.createContext<
  'light' | 'dark' | 'lightOverwritten' | 'darkv2' | null
>(null)

export default LayoutColorThemeContext
